// extracted by mini-css-extract-plugin
export default {"error":"wOMaC","success":"Giu_l"};